import React from 'react'

export const LoadingProjectCard = () => {
    return (
        <div className="project_card loading"></div>
    )
}
